import Input from './Input'
export { default as StyledInput } from './StyledInput'

export default Input
